



























































































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mapState } from 'vuex'
import ContactForm from '~/components/sales_map_v3/ContactForm.vue'
import LotInfo from '~/models/lotInfo'
import { PublicProject } from '~/models/project'
import Lot from '~/models/lot'
import Plan from '~/models/plan'
import { FavouriteLot } from '~/models'
import { LotTypes } from '~/enums/lots'
import globalStyling from '~/mixins/globalStyling'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import HomeSidePanel from '~/components/consumer_map_v3/HomeSidePanel.vue'
import HomesiteSidePanel from '~/components/consumer_map_v3/HomesiteSidePanel.vue'
import HomeViewSidePanel from '~/components/consumer_map_v3/HomeViewSidePanel.vue'
import {
  isItemInFavs,
  setLocalStorageFavouriteItem,
  storageAvailable,
} from '~/utils/localStorage'
import { getParentURL } from '~/utils/utils'
import { favoritesStore } from '~/store'
import ShareModal from '~/components/sales_map_v3/ShareModal.vue'

import 'swiper/css/swiper.css'
import { Events } from '~/utils/eventLayers'
import HubspotFormComponent from '~/components/forms/HubspotForm.vue'

@Component({
  components: {
    HomeSidePanel,
    HomesiteSidePanel,
    HomeViewSidePanel,
    ShareModal,
    ContactForm,
    HubspotFormComponent,
  },
  mixins: [globalStyling, LotUtilsMixin],
  computed: {
    ...mapState('consumer-map', {
      parentPageBaseURL: 'parentPageBaseURL',
    }),
  },
})
export default class SideModal extends mixins(globalStyling, LotUtilsMixin) {
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: null }) models: Lot[]
  @Prop({ default: null }) filters: any
  @Prop({ default: null }) plan: Plan
  @Prop({ default: null }) lots: Array<Lot>

  lotType: string = LotTypes.HOME
  isSaved: Boolean = false
  showShareModal: Boolean = false
  sharedUrl: string = ''
  planSelected: Plan = null
  planName: string = null
  elevationSelected: number = null
  elevationName: string = null
  elevation: any = null
  lotSelected: number = null
  urlPlanId: number = null
  urlElevationId: number = null
  lotInfoSelected: LotInfo = null
  activeView: 'details' | 'contact' = 'details'
  parentPageBaseURL!: string
  sideModalNavHeight: number = null

  mounted() {
    this.calculateSideModalNavHeight()
    window.addEventListener('resize', this.calculateSideModalNavHeight)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateSideModalNavHeight)
  }

  created() {
    if (!this.plan) {
      this.lotType = this.getLotType(this.project, this.lotInfo)
      if (this.lotType === LotTypes.HOME) {
        const planId =
          this.lotInfo.architectural_submission?.master_plan?.plan?.id
        const elevationId =
          this.lotInfo.architectural_submission?.master_plan?.id
        const favObject: FavouriteLot = {
          id: String(this.lotInfo.id),
          plan_id: planId ? String(planId) : null,
          elevation_id: elevationId ? String(elevationId) : null,
        }
        this.isSaved = isItemInFavs(favObject, 'lot')
      } else {
        const favObject: FavouriteLot = {
          id: String(this.lotInfo.id),
          plan_id: this.planSelected ? String(this.planSelected.id) : null,
          elevation_id: this.elevationSelected
            ? String(this.elevationSelected)
            : null,
        }
        this.isSaved = isItemInFavs(favObject, 'lot')
      }
      const { plan_id, elevation_id } = this.$route.query
      this.urlPlanId = plan_id ? Number(plan_id) : null
      this.urlElevationId = elevation_id ? Number(elevation_id) : null
    } else {
      this.planSelected = this.plan
    }
  }

  setWindowSize() {
    const value = !this.plan ? 90 : 0
    if (window.visualViewport) {
      return window.visualViewport.height - value
    } else {
      return window.innerHeight - value
    }
  }

  get displayHubSpotForm() {
    if (
      this.project.hubspot_form?.portal_id &&
      this.project.hubspot_form?.form_id
    ) {
      return true
    }
    return false
  }

  get showPDFSummary() {
    if (this.isVisible('--ad-sp-button-pdf-summary') && this.lotInfo) {
      if (
        (this.planSelected && this.elevationSelected) ||
        this.lotType === LotTypes.HOME
      ) {
        return true
      }
    }
  }

  get enableFavoriting() {
    const bypassChecks = this.isVisible('--ad-sp-bypass-favorite-checks')
    if (
      this.lotInfo?.type === LotTypes.HOME ||
      (this.planSelected &&
        (this.elevationSelected || bypassChecks) &&
        (this.lotSelected || this.lotInfo))
    ) {
      return true
    }
    return false
  }

  get contactFormFields() {
    return structuredClone(this.project.config.contact_form_fields) // this will create a deep copy of the object
  }

  get requestInfoButtonLabel() {
    return (
      this.getStyleVariableValue('--v3-cm-button-request-info-label')?.replace(
        /['"]+/g,
        ''
      ) || 'Request Info'
    )
  }

  get saveButtonLabel() {
    return (
      this.getStyleVariableValue('--v3-cm-button-save-label')?.replace(
        /['"]+/g,
        ''
      ) || 'Save'
    )
  }

  get printButtonLabel() {
    return (
      this.getStyleVariableValue('--v3-cm-button-print-label')?.replace(
        /['"]+/g,
        ''
      ) || 'PDF/Print'
    )
  }

  get shareButtonLabel() {
    return (
      this.getStyleVariableValue('--v3-cm-button-share-label')?.replace(
        /['"]+/g,
        ''
      ) || 'Share'
    )
  }

  get isStorageEnabled(): boolean {
    return storageAvailable()
  }

  get isHome(): boolean {
    return !this.isPlan && this.lotType === LotTypes.HOME
  }

  get isModel(): boolean {
    return !this.isPlan && this.lotType === LotTypes.RESERVED
  }

  get isHomeSite(): boolean {
    return !this.isPlan && this.lotType === LotTypes.HOME_SITE
  }

  get isPlan(): boolean {
    return !!this.plan
  }

  getPDFSummaryURL(): string {
    let url =
      this.lotInfo?.slug &&
      `/o/api/map/consumer/${this.lotInfo.slug}/pdf_summary`
    if (this.isHomeSite && this.planSelected && this.elevationSelected) {
      url = `${url}?plan_id=${this.planSelected.id}&elevation_id=${this.elevationSelected}`
    }

    let model = null
    if (this.isHomeSite) {
      model = this.homesiteModel
    } else if (this.isHome) {
      model = this.homeModel
    }

    if (model) {
      url = url.includes('?')
        ? `${url}&model=${model.id}`
        : `${url}?model=${model.id}`
    }
    return url
  }

  save() {
    if (!this.isPlan) {
      this.isSaved = !this.isSaved
    }
  }

  get sideModalWidth(): string {
    if (this.isHome || this.isModel) {
      return 'md:w-4/5 max-w-3xl'
    }
    if (this.isPlan) {
      return 'md:w-4/5 max-w-6xl'
    }
    if (this.isHomeSite) {
      return 'md:w-4/5 lg:w-4/5 xl:w-1/2 max-w-3xl'
    }
  }

  saveFavItem() {
    if (!storageAvailable()) {
      return
    }
    let selectedLotId = null
    if (this.lotInfo) {
      selectedLotId = this.lotInfo.id
    }

    if (this.lotSelected) {
      selectedLotId = this.lotSelected
    }

    const planId = this.lotInfo.architectural_submission
      ? this.lotInfo.architectural_submission.master_plan.plan.id
      : this.planSelected?.id

    const elevationId = this.lotInfo.architectural_submission
      ? this.lotInfo.architectural_submission.master_plan.id
      : this.elevationSelected

    if (selectedLotId) {
      const favObject: FavouriteLot = {
        id: String(selectedLotId),
        plan_id: planId ? String(planId) : null,
        elevation_id: elevationId ? String(elevationId) : null,
      }

      if (!this.lotInfo?.architectural_submission) {
        // for home sites
        favObject.plan_id = this.planSelected
          ? String(this.planSelected.id)
          : null
        favObject.elevation_id = this.elevationSelected
          ? String(this.elevationSelected)
          : null
      }

      setLocalStorageFavouriteItem(favObject, 'lot')

      if (this.isSaved) {
        favoritesStore.removeFavorite({ ...favObject, item_type: 'lot' })
      } else {
        favoritesStore.addFavorite({ ...favObject, item_type: 'lot' })
      }

      this.isSaved = !this.isSaved
    }
  }

  shareUrl() {
    const { origin, pathname } = window.location
    let output = ''
    const parentURL = getParentURL(this.parentPageBaseURL)

    output = parentURL.origin
      ? parentURL.origin
      : `${origin}${pathname.replace('plans', '')}`
    output += this.isPlan ? `plans` : `?slug=${this.lotInfo.slug}`

    if (this.planSelected) {
      output += output.includes('?') ? `&` : `?`
      output += `plan_id=${this.planSelected.id}`
      if (this.elevationSelected) {
        output += `&elevation_id=${this.elevationSelected}`
      }
      if (this.lotSelected) {
        output += `&lot_id=${this.lotSelected}`
      }
    }
    this.sharedUrl = `${output}${parentURL.extraParams}`
    this.showShareModal = true

    let category: string = ''
    let builder: string = ''

    if (this.lotInfo) {
      builder = this.lotInfo?.builder ? this.lotInfo.builder.name : '-'
      category = this.lotInfo.type === LotTypes.HOME_SITE ? 'homesite' : 'home'
    } else if (this.plan) {
      builder = this.plan?.builder ? this.plan.builder.name : '-'
      category = 'plan'
    }

    Events.actions(
      'actionClick',
      `click | share ${category}`,
      category,
      builder,
      this.lotInfo,
      this.plan
    )
  }

  onPlanSelection(plan: Plan) {
    this.planSelected = plan || null
    this.planName = plan?.name || null
    this.isSaved = false
    const favObject: FavouriteLot = {
      id: this.lotInfo ? String(this.lotInfo.id) : null,
      plan_id: this.planSelected ? String(this.planSelected.id) : null,
      elevation_id: this.elevationSelected
        ? String(this.elevationSelected)
        : null,
    }
    if (this.lotInfo) {
      this.isSaved = isItemInFavs(favObject, 'lot')
    }
  }

  onElevationSelection(elevation: { id: number; name: string; slug: string }) {
    this.elevationSelected = elevation?.id
    this.elevationName = elevation?.name
    this.elevation = elevation
    this.isSaved = false
    const favObject: FavouriteLot = {
      id: this.lotInfo ? String(this.lotInfo.id) : null,
      plan_id: this.planSelected ? String(this.planSelected.id) : null,
      elevation_id: this.elevationSelected
        ? String(this.elevationSelected)
        : null,
    }
    if (this.lotInfo) {
      this.isSaved = isItemInFavs(favObject, 'lot')
    }
  }

  onLotSelection(lot: LotInfo) {
    this.lotInfoSelected = lot
    this.lotSelected = lot?.id
    const favObject: FavouriteLot = {
      id: this.lotInfo ? String(this.lotInfo.id) : null,
      plan_id: this.planSelected ? String(this.planSelected.id) : null,
      elevation_id: this.elevationSelected
        ? String(this.elevationSelected)
        : null,
    }
    this.isSaved = isItemInFavs(favObject, 'lot')
  }

  getPlanSelected(): number | null {
    const plan = this.planSelected ? this.planSelected : null
    return plan || this.lotInfo?.architectural_submission?.master_plan?.plan
  }

  getElevationSelected(): number | null {
    return this.elevation || this.lotInfo?.architectural_submission?.master_plan
  }

  onSaveFav(lotId: number) {
    if (!storageAvailable()) {
      return
    }
    if (lotId) {
      const favObject: FavouriteLot = {
        id: String(lotId),
        plan_id: this.planSelected ? String(this.planSelected.id) : null,
        elevation_id: this.elevationSelected
          ? String(this.elevationSelected)
          : null,
      }

      setLocalStorageFavouriteItem(favObject, 'lot')

      const isSaved = isItemInFavs(favObject, 'lot')
      if (isSaved) {
        favoritesStore.addFavorite({ ...favObject, item_type: 'lot' })
      } else {
        favoritesStore.removeFavorite({ ...favObject, item_type: 'lot' })
      }

      if (this.lotSelected === lotId) {
        this.isSaved = isSaved
      }
    }
  }

  showRequestInfo(): void {
    this.activeView = 'contact'
    let category: string = ''
    let builder: string = ''
    let page: string = ''

    if (this.lotInfo) {
      builder = this.lotInfo?.builder ? this.lotInfo.builder.name : '-'
      category = this.lotInfo.type === LotTypes.HOME_SITE ? 'homesite' : 'home'
      page = 'map'
    } else if (this.plan) {
      builder = this.plan?.builder ? this.plan.builder.name : '-'
      category = 'plan'
      page = 'plan'
    }

    Events.requestInfo(
      'requestInfo',
      category,
      `click | request info ${category}`,
      builder,
      page,
      this.lotInfo,
      this.plan
    )
  }

  // If the model has a model_home_address_id this will return the corresponding lot to the id
  redirectModel(model: any) {
    if (model && model.model_home_address_id) {
      const newModel = this.models.find(
        (newModel) => newModel.id === model.model_home_address_id
      )
      return newModel || model
    }
    return model
  }

  get homeModel() {
    // find all the models from the same builder
    const models = this.models?.filter(
      (model: any) => model?.builder?.name === this.lotInfo.builder?.name
    )
    // if there aren't models bail
    if (!models || models.length === 0) {
      return
    }

    // the model that matches the plan and the elevation is the one that we need to show
    const master_plan = this.lotInfo.architectural_submission?.master_plan
    let matchingModel = null

    // if the lot doesn't have a master plan return the first model of the builder
    if (!master_plan) {
      return this.redirectModel(models[0])
    }

    matchingModel = models.find((model) => {
      const model_spec = model.architectural_submission
      if (model_spec && model_spec.master_plan && model_spec.master_plan.plan) {
        return (
          model_spec.master_plan.id === master_plan.id &&
          model_spec.master_plan.plan.id === master_plan.plan.id
        )
      }
      return false
    })

    // if there is not any model that matches the lot's elevation the suggest one based on the elevation size
    if (!matchingModel) {
      const matchingModelBySize = models.find((model) => {
        const model_spec = model.architectural_submission
        if (
          !model_spec ||
          !model_spec.master_plan ||
          !model_spec.master_plan.plan
        ) {
          return false
        }

        return model_spec.master_plan.plan.size.some((size) =>
          master_plan?.plan.size.includes(size)
        )
      })

      if (!matchingModelBySize) {
        return this.redirectModel(models[0])
      }

      return this.redirectModel(matchingModelBySize)
    }

    return this.redirectModel(matchingModel)
  }

  get homesiteModel() {
    const selectedModel = this.models?.find(
      (model: any) =>
        model?.builder?.name === this.lotInfo.builder?.name &&
        model?.size === this.lotInfo.size
    )
    return this.redirectModel(selectedModel)
  }

  getColor() {
    const color = this.getStyleVariableValue('--cm-sp-fav-fill')?.replace(
      /['"]+/g,
      ''
    )
    if (color) return { color }
    return {}
  }

  getOutlineColor() {
    const color = this.getStyleVariableValue('--cm-sp-fav-outline')?.replace(
      /['"]+/g,
      ''
    )
    if (color) return { color }
    return {}
  }

  calculateSideModalNavHeight() {
    const element = this.$refs.sideModalNav as HTMLElement
    if (element) {
      this.sideModalNavHeight = element.clientHeight
    }
  }
}
